import {wrappedFetch} from "./Functions";

export default async function Post(end, body){
    // return await fetch("http://localhost:8080/"+end,{
    const bodyData = JSON.stringify(body);
    return wrappedFetch('/'+end,{
        headers:{
            "Content-Type":"application/json",
            'accept':"*/*",
        },
        method:"POST",
        body: bodyData,
    })
}